import type { QueryClient } from '@tanstack/react-query';
import { Link, Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { EmptyState, buttonVariants } from '@wundo/ui';
import { useUserTheme } from '@wundo/client/useUserTheme.ts';
import { useImpersonatedBy } from '@wundo/client/impersonation.ts';

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFound,
});

function RootLayout() {
  /* Signed in as a customer, the console keeps the staff member's own theme. */
  useUserTheme({ skip: useImpersonatedBy() !== null });

  return <Outlet />;
}

/*
 * Outside the shell on purpose: an address that does not exist is not a page of
 * this console, and drawing the navigation around it invites a second guess at
 * the same wrong URL.
 */
function NotFound() {
  return (
    <main className='flex h-dvh items-center justify-center px-7'>
      <EmptyState
        title='Page not found'
        description='That address does not exist here, or it has moved.'
        action={
          <Link to='/' className={buttonVariants({ variant: 'accent' })}>
            Go to the start page
          </Link>
        }
      />
    </main>
  );
}
